var _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 31.4,
    height: 31.4,
    rx: 15.7,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 31.4,
    height: 31.4,
    rx: 15.7,
    stroke: "#E5E5E5",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9463 10.9104L21.4815 18.4292C21.3627 20.3502 21.3034 21.3107 20.8219 22.0013C20.5838 22.3427 20.2773 22.6309 19.9218 22.8474C19.2029 23.2854 18.2405 23.2854 16.3158 23.2854C14.3886 23.2854 13.425 23.2854 12.7056 22.8466C12.3499 22.6297 12.0433 22.341 11.8053 21.999C11.3239 21.3074 11.2659 20.3455 11.1497 18.4218L10.6963 10.9104",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57129 10.9106H23.0713M19.3631 10.9106L18.8511 9.85444C18.511 9.15284 18.3409 8.80203 18.0476 8.58325C17.9825 8.53472 17.9136 8.49155 17.8415 8.45417C17.5167 8.28564 17.1269 8.28564 16.3472 8.28564C15.5479 8.28564 15.1483 8.28564 14.818 8.46123C14.7449 8.50015 14.675 8.54507 14.6093 8.59552C14.3125 8.82317 14.1468 9.18681 13.8152 9.91409L13.361 10.9106",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4463 19.1606V14.6606",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1963 19.1606V14.6606",
    stroke: "#212129",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8e56ee121fc733e45c0a404057d79450.svg";
export { ForwardRef as ReactComponent };